import styled from 'styled-components'

export const FileInput = styled.input`
  display: none;
`

export const ExampleLink = styled.a`
  color: inherit;
  text-decoration: none;
`
